module.exports = __webpack_public_path__ + "img/map_cropped_scaled.a66e725e.png";